import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
    filter: null,
    status: 'idle',
    error: null
};

const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        reset: (state) => initialState,
        setFilter: (state, action) => {
            return {
              ...state,
              filter: action.payload,
            }
        }
    },
});

export const { reset, setFilter } = filterSlice.actions;
export const selectFilter = state => state.filter.filter;
export const selectFilterStatus = state => state.filter.status;
export const selectFilterError = state => state.filter.error;
export default filterSlice.reducer;
